module.exports = __webpack_public_path__ + "static/media/clothes_01.047a68ef.svg";